/* Third Party */
import React from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { Provider } from "react-redux";

/* Layout Components */
import Default from "./components/layouts/default";

/* Store */
import { globalStore } from "./store";

import { msalConfig } from "../src/config/authentication/azure/authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

const App = () => {
  return (
    <Provider store={globalStore}>
      <MsalProvider instance={msalInstance}>
        <Default />
      </MsalProvider>
    </Provider>
  );
};

export default App;
